import { useContext, useState } from "react";
import {
  Dialog,
  DialogContent,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Box,
  Grid,
  Typography,
  Stack,
  Avatar,
} from "@mui/material";
import moment from "moment";
// Project imports
import "../../../Style/dialogstyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import { SelectStudentByClass } from "../../Include/DynamicSelect/DynamicSelect";
import { DialogTitleComp } from "../../../Utils/Component";
import useGetAttByClassAndDate from "../../../Hooks/useGetAttByClassAndDate";
import useWithDimension from "../../../Hooks/useWithDimension";
import LoadingPage from "../../../Utils/LoadingPage";
import EmptyData from "../../Include/EmptyData/EmptyData";
import { SelectDatePicker } from "../../Include/SelectDatePicker/SelectDatePicker";

export default function ViewAttendnaceReport({ classId, open, handleClose }) {
  const { t } = useContext(AuthContext);

  const { width } = useWithDimension();
  const now = new Date();

  const defaultFromDate = new Date(now.getFullYear(), now.getMonth(), 1); // First day of month
  const defaultToDate = new Date(now.getFullYear(), now.getMonth() + 1, 0); // Last day of month

  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [toDate, setToDate] = useState(defaultToDate);
  const { attData, loading, refetch } = useGetAttByClassAndDate({
    classId: classId,
    fromDate: moment(fromDate).format("YYYY-MM-DD"),
    toDate: moment(toDate).format("YYYY-MM-DD"),
  });

  // console.log("attData::", attData);

  return (
    <Dialog open={open} className="dialog-container" fullScreen>
      <DialogTitleComp
        title={t("modal_title_view_attendance")}
        classTitle="dialog-title"
        classIcon="close-icon"
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <Box sx={{ marginTop: "20px" }}>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className={t("class-name-text-field-title")}>
                {t("thead_from_date")}
              </Typography>
              <SelectDatePicker
                value={fromDate}
                onChange={(val) => setFromDate(val)}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className={t("class-name-text-field-title")}>
                {t("thead_to_date")}
              </Typography>
              <SelectDatePicker
                value={toDate}
                onChange={(val) => setToDate(val)}
              />
            </Grid>
          </Grid>
        </Box>

        <Box>
          <TableContainer sx={{ maxWidth: `${width}px` }}>
            <Table className="table">
              <TableHead className="header-row">
                <TableRow>
                  <TableCell
                    className={t("class-name-header-title-start")}
                    sx={{
                      width: "5% !important",
                      position: "sticky",
                      left: 0,
                      background: "white",
                      zIndex: 1000,
                      top: 0, // Keep it at the top
                    }}
                  >
                    {t("thead_no")}
                  </TableCell>

                  <TableCell
                    className={t("class-name-header-title")}
                    sx={{
                      position: "sticky",
                      left: "50px",
                      background: "white",
                      zIndex: 1000,
                      top: 0, // Keep it at the top
                    }}
                  >
                    {t("thead_name")}
                  </TableCell>

                  {/* <TableCell className={t("class-name-header-title")}>
                    {t("thead_gender")}
                  </TableCell> */}

                  {attData?.attLenght?.length > 0
                    ? attData?.attLenght?.map((day, index) => {
                        return (
                          <TableCell
                            key={index}
                            className={t("class-name-header-title")}
                            // sx={{ width: "1% !important" }}
                          >
                            {day}
                          </TableCell>
                        );
                      })
                    : null}

                  <TableCell
                    className={t("class-name-header-title")}
                    sx={{
                      // width: "5% !important",
                      position: "sticky",
                      right: "240px",
                      background: "white",
                      zIndex: 1000,
                      top: 0,
                    }}
                  >
                    {t("thead_present")}
                  </TableCell>
                  <TableCell
                    className={t("class-name-header-title")}
                    sx={{
                      // width: "5% !important",
                      position: "sticky",
                      right: "160px",
                      background: "white",
                      zIndex: 1000,
                      top: 0,
                    }}
                  >
                    {t("thead_late")}
                  </TableCell>
                  <TableCell
                    className={t("class-name-header-title")}
                    sx={{
                      // width: "5% !important",
                      position: "sticky",
                      right: "80px",
                      background: "white",
                      zIndex: 1000,
                      top: 0,
                    }}
                  >
                    {t("thead_permission")}
                  </TableCell>
                  <TableCell
                    className={t("class-name-header-title")}
                    sx={{
                      // width: "5% !important",
                      position: "sticky",
                      right: 0,
                      background: "white",
                      zIndex: 1000,
                      top: 0,
                    }}
                  >
                    {t("thead_absent")}
                  </TableCell>

                  <TableCell
                    className={t("class-name-header-title-end")}
                  ></TableCell>
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody className="body">
                  <TableRow className="body-row">
                    <TableCell colSpan={10} className="body-cell">
                      <LoadingPage />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <>
                  {attData?.studentData?.length === 0 ? (
                    <TableBody className="body">
                      <TableRow className="body-row">
                        <TableCell colSpan={10} className="body-cell">
                          <EmptyData />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : (
                    <TableBody className="body">
                      {attData?.studentData?.map((row, index) => {
                        return (
                          <TableRow className={"body-row"} key={index}>
                            <TableCell
                              className="body-cell-start"
                              sx={{
                                width: "5% !important",
                                position: "sticky",
                                left: 0,
                                background: "white",
                                zIndex: 900,
                              }}
                            >
                              {index + 1}
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              sx={{
                                width: "8% !important",
                                position: "sticky",
                                left: "50px",
                                background: "white",
                                zIndex: 900,
                              }}
                            >
                              <Stack direction="row" spacing={1.4}>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Avatar
                                    sx={{ width: 40, height: 40 }}
                                    alt={row?.studentId?.studentName}
                                    src={row?.studentId?.profile}
                                  />
                                </Stack>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Typography className="student-name">
                                    {row?.studentId?.familyName +
                                      " " +
                                      row?.studentId?.studentName}
                                  </Typography>
                                </Stack>
                              </Stack>
                            </TableCell>

                            {/* <TableCell className="body-cell">
                              {row?.studentId?.gender === "Male"
                                ? t("thead_male")
                                : t("thead_female")}
                            </TableCell> */}

                            {row?.attReports?.map((att, index) => {
                              return (
                                <TableCell key={index} className="body-cell">
                                  <Typography className={att?.toString()}>
                                    {att === "present"
                                      ? "C"
                                      : att === "late"
                                      ? "L"
                                      : att === "permission"
                                      ? "P"
                                      : att === "absent"
                                      ? "A"
                                      : ""}
                                  </Typography>
                                </TableCell>
                              );
                            })}

                            <TableCell
                              className="body-cell"
                              sx={{
                                // width: "5% !important",
                                position: "sticky",
                                right: "240px",
                                background: "white",
                                zIndex: 1000,
                                top: 0, // Keep it at the top
                              }}
                            >
                              <Typography className="present">
                                {row?.present}
                              </Typography>
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              sx={{
                                // width: "5% !important",
                                position: "sticky",
                                right: "160px",
                                background: "white",
                                zIndex: 1000,
                                top: 0, // Keep it at the top
                              }}
                            >
                              <Typography className="late">
                                {row?.late}
                              </Typography>
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              sx={{
                                // width: "5% !important",
                                position: "sticky",
                                right: "80px",
                                background: "white",
                                zIndex: 1000,
                                top: 0, // Keep it at the top
                              }}
                            >
                              <Typography className="permission">
                                {row?.permission}
                              </Typography>
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              sx={{
                                // width: "8% !important",
                                position: "sticky",
                                right: 0,
                                background: "white",
                                zIndex: 1000,
                                top: 0, // Keep it at the top
                              }}
                            >
                              <Typography className="absent">
                                {row?.absent}
                              </Typography>
                            </TableCell>

                            <TableCell
                              className="body-cell-end"
                              align="right"
                            ></TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                </>
              )}
            </Table>
          </TableContainer>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
